import { Field } from 'redux-form';
import { Stepper } from '@optimus-web/core';
import { getError } from '../../utils';

interface StepperFieldRendererProps {
    input?: $TSFixMe; // TODO: pt.shape(fieldInputPropTypes from redux-form)
    meta?: $TSFixMe; // TODO: pt.shape(fieldMetaPropTypes from redux-form)
}

const StepperFieldRenderer = ({ input, meta, ...other }: StepperFieldRendererProps) => {
    const { onChange } = input;
    const handleChange = (event: $TSFixMe, value: $TSFixMe) => {
        onChange(value);
    };

    return <Stepper error={getError(meta)} {...input} {...other} onChange={handleChange} />;
};

const StepperField = (props: $TSFixMe) => <Field component={StepperFieldRenderer} {...props} />;
StepperField.defaultProps = {
    parse: (value: $TSFixMe) => window.parseInt(value, 10),
};

export default StepperField;
